<script lang="ts">
    import IconResetSimulation from '../icons/ResetSimulation.svelte';
    import IconFullscreen from '../icons/Fullscreen.svelte';

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher<{machineProgramStateChange: MachineStateMealy}>();

    import DoorSystem from "../mealyModels/DoorSystem/DoorSystem.svelte";
    import MealyPane from "./MealyPane.svelte";
    import { setUpdateMachineState } from './context';
    import MealyNodeMenu from './MealyNodeMenu.svelte';
    import MealyTransitionMenu from './MealyTransitionMenu.svelte';
    import AmpelSystem from '../mealyModels/AmpelSystem/AmpelSystem.svelte';
    import { MealyModelType } from '../mealyModels/mealyModelType';
    import type { MachineStateMealy } from '../state/machineState';
    import type { EditMode } from '../state/uiState';
    import KunstautomatSystem1 from '../mealyModels/Kunstautomat/KunstautomatSystem1.svelte';
    import KunstautomatSystem2 from '../mealyModels/Kunstautomat/KunstautomatSystem2.svelte';
    import { machineState_errors } from './mealyErrorsInMachine';
    import PopUpMessage from '../PopUpMessage.svelte';
    import GaragentorSystem from '../mealyModels/Garagentor/GaragentorSystem.svelte';
    import { getConfiguration } from '../context';
    import { mealyMachine_startExecution } from '../actions/machine';
    import CodeschlossSystem from '../mealyModels/Codeschloss/CodeschlossSystem.svelte';
    import { machineState_popUpMessage_hide } from '../actions/popUpMessage';

    export let machineState: MachineStateMealy;
    export let editMode: EditMode;
    export let onToggleFullscreen = () => {};

    const conf = getConfiguration();

    function updateMachineProgramState(newMachineProgramState: MachineStateMealy) {
        if (newMachineProgramState.machine === machineState.machine) {
            // Es gab keine Änderung in machine
            // console.log('Es gab keine Änderung in machine')
            dispatch('machineProgramStateChange', newMachineProgramState);
        } else {
            // es gab Änderungen in Machine
            // console.log('es gab Änderungen in Machine');
            dispatch('machineProgramStateChange', machineState_errors(newMachineProgramState));
        }
    }

    function handleResetClick() {
        updateMachineProgramState(mealyMachine_startExecution(machineState));    
    }

    function handleFullscreenClick() {
        onToggleFullscreen();
    }

    setUpdateMachineState(updateMachineProgramState);

    function handleClosePopUpMessage() {
        updateMachineProgramState(machineState_popUpMessage_hide(machineState));
    }
</script>

<!-- <div style="flex-grow: 1; display: flex;"> -->
<div style="display: flex; height: 100%;">
    <!-- Pane mit Menüs, die in der Pane als Overlay angezeigt werden -->
    <div style="position: relative; flex-grow: 1; flex-shrink: 0; margin-right: 10px; min-width: 400px;">
        <MealyPane
            machineState={machineState}
            editMode={editMode}
        />
        {#if machineState.uiState.selection.stateId !== undefined}
            <MealyNodeMenu machineState={machineState} />
        {/if}
        {#if machineState.uiState.selection.transitionId !== undefined}
            <MealyTransitionMenu machineState={machineState} />
        {/if}
        <!-- {#if machineState.popUpMessage.isVisible}
            <PopUpMessage 
                message={machineState.popUpMessage.message}
                onClosePopUpMessage={handleClosePopUpMessage}
            />
        {/if} -->
    </div>

    <!-- alles, was rechts von der Pane ist  -->
    <div style="display: flex; flex-shrink: 0; flex-direction: column;">
        {#if conf.showResetSimulationButton}
            <div style="flex-grow: 0; background-color: white; border-radius: 10px; padding: 10px; margin-bottom: 10px;">
                <!-- <div style="display: flex;  align-items: center;">
                    <div style="flex-grow: 1"/>
                    <button
                        class="automaten-simulator-iconButton" 
                        on:click={handleResetClick}
                    >
                        <IconResetSimulation />
                    </button>
                    <span style="padding-left: 10px;">
                        zurücksetzen
                    </span>
                    <div style="flex-grow: 1"/>
                </div> -->
                <div style="display: grid; grid-template-columns: 1fr 50px 180px 1fr; row-gap: 10px;">
                    <div style="grid-column: 2; grid-row: 1">
                        <button
                            class="automaten-simulator-iconButton" 
                            on:click={handleResetClick}
                        >
                            <IconResetSimulation />
                        </button>
                    </div>
                    <div style="grid-column: 3; grid-row: 1">
                        Simulation zurücksetzen
                    </div>
                    <div style="grid-column: 2; grid-row: 2">
                        <button
                            class="automaten-simulator-iconButton" 
                            on:click={handleFullscreenClick}
                        >
                            <IconFullscreen />
                        </button>
                    </div>
                    <div style="grid-column: 3; grid-row: 2">
                        Vollbild
                    </div>
                </div>
            </div>

        {:else}
            <div style="flex-grow: 1"></div>
        {/if}

        <div style="background-color: white; border-radius: 10px; padding: 10px;">
            {#if machineState.mealyModelType === MealyModelType.DOORSYSTEM}
                <DoorSystem
                    machineState={machineState}
                    isExecuting={editMode === "EXECUTION"}
                    mealyExecutionState={machineState.executionState}
                />
            {/if}
            {#if machineState.mealyModelType === MealyModelType.KUNSTAUTOMAT1}
                <KunstautomatSystem1
                    machineState={machineState}
                    isExecuting={editMode === "EXECUTION"}
                    mealyExecutionState={machineState.executionState}
                />
            {/if}
            {#if machineState.mealyModelType === MealyModelType.KUNSTAUTOMAT2}
                <KunstautomatSystem2
                    machineState={machineState}
                    isExecuting={editMode === "EXECUTION"}
                    mealyExecutionState={machineState.executionState}
                />
            {/if}
            {#if machineState.mealyModelType === MealyModelType.AMPELSYSTEM}
                <AmpelSystem 
                    machineState={machineState}
                    isExecuting={editMode === "EXECUTION"}
                    mealyExecutionState={machineState.executionState}
                />
            {/if}
            {#if machineState.mealyModelType === MealyModelType.GARAGENTOR}
                <GaragentorSystem 
                    machineState={machineState}
                    isExecuting={editMode === "EXECUTION"}
                    mealyExecutionState={machineState.executionState}
                />
            {/if}
            {#if machineState.mealyModelType === MealyModelType.CODESCHLOSS}
                <CodeschlossSystem 
                    machineState={machineState}
                    isExecuting={editMode === "EXECUTION"}
                    mealyExecutionState={machineState.executionState}
                />
            {/if}
        </div>
        <div style="flex-grow: 1"></div>
    </div>
</div>

{#if machineState.popUpMessage.isVisible}
    <PopUpMessage 
        message={machineState.popUpMessage.message}
        onClosePopUpMessage={handleClosePopUpMessage}
    />
{/if}